import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext, useCart } from "../../contexts/CartContext"; // Import CartContext

const OrderPage = () => {
  const navigate = useNavigate();
  const { cartProducts } = useCart(); // Access cartProducts from CartContext

  // Calculate total price
  const total = cartProducts
    .reduce((acc, product) => acc + product.price * product.qty, 0)
    .toFixed(2);

  return (
    <div className="bg-white dark:bg-black min-h-screen p-6">
      <div className="max-w-2xl mx-auto bg-gray-100 dark:bg-gray-800 rounded-lg shadow-lg p-6">
        <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
          Order Confirmation
        </h1>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          Thank you for your order! Your order ID is:{" "}
          <strong>#{Math.floor(Math.random() * 1000000)}</strong>
        </p>
        <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-2">
          Order Summary
        </h2>
        <div className="rounded-lg p-4 bg-gray-200 dark:bg-gray-700">
          {cartProducts.map((item, index) => (
            <div key={index} className="flex items-center space-x-4 mb-2">
              <img
                src={item.photo[0].url}
                alt={item.name}
                className="w-16 h-16 object-cover rounded"
              />
              <div className="flex-grow">
                <p className="font-semibold text-gray-700 dark:text-gray-300">
                  {item.name} (x{item.qty})
                </p>
                <p className="text-sm text-gray-400 dark:text-gray-400">
                  Price: {item.price} KWD each
                </p>
              </div>
              <p className="font-bold text-gray-700 dark:text-gray-300">
                {(item.price * item.qty).toFixed(2)} KWD
              </p>
            </div>
          ))}
        </div>
        <div className="flex justify-between font-bold text-gray-800 dark:text-white mt-4">
          <span>Total:</span>
          <span>{total} KWD</span>
        </div>
        <button
          onClick={() => navigate("/")}
          className="mt-4 bg-yellow-500 text-white py-2 px-4 rounded-full hover:bg-yellow-600 transition duration-200"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default OrderPage;
